module.exports = __webpack_public_path__ + "static/img/001.87914943.png";